module.exports = __webpack_public_path__ + "img/腾讯公益@2x.401b64dc.png";